var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7427 12L21.0427 7.7C20.5352 7.19741 20.2475 6.51422 20.2427 5.8C20.2676 5.06532 20.5706 4.36753 21.0904 3.84773C21.6102 3.32794 22.308 3.02493 23.0427 3C23.7678 3.02591 24.4546 3.33233 24.9582 3.85464C25.4619 4.37696 25.7431 5.0744 25.7427 5.8C26.2134 5.77427 26.6829 5.86779 27.1078 6.07188C27.5327 6.27598 27.8992 6.58404 28.1734 6.96751C28.4475 7.35099 28.6204 7.79747 28.676 8.26556C28.7316 8.73366 28.6681 9.20821 28.4914 9.64523C28.3147 10.0823 28.0306 10.4676 27.6653 10.7656C27.3001 11.0635 26.8655 11.2644 26.4019 11.3497C25.9383 11.4349 25.4606 11.4017 25.0133 11.2532C24.5659 11.1047 24.1633 10.8456 23.8427 10.5L19.5427 14.9",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7427 12L21.0427 7.7C20.5352 7.19741 20.2475 6.51422 20.2427 5.8C20.2676 5.06532 20.5706 4.36753 21.0904 3.84773C21.6102 3.32794 22.308 3.02493 23.0427 3C23.7678 3.02591 24.4546 3.33233 24.9582 3.85464C25.4619 4.37696 25.7431 5.0744 25.7427 5.8C26.2134 5.77427 26.6829 5.86779 27.1078 6.07188C27.5327 6.27598 27.8992 6.58404 28.1734 6.96751C28.4475 7.35099 28.6204 7.79747 28.676 8.26556C28.7316 8.73366 28.6681 9.20821 28.4914 9.64523C28.3147 10.0823 28.0306 10.4676 27.6653 10.7656C27.3001 11.0635 26.8655 11.2644 26.4019 11.3497C25.9383 11.4349 25.4606 11.4017 25.0133 11.2532C24.5659 11.1047 24.1633 10.8456 23.8427 10.5L19.5427 14.9",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1425 20.8C18.2109 22.5437 17.6691 24.2567 16.6104 25.6439C15.5517 27.0312 14.0424 28.0058 12.3425 28.4C11.1607 28.6784 9.92947 28.6695 8.75181 28.3743C7.57415 28.079 6.48437 27.506 5.5737 26.703C4.66304 25.9001 3.958 24.8906 3.5176 23.7592C3.07721 22.6278 2.91429 21.4073 3.04248 20.2C3.21567 18.3517 4.06817 16.6333 5.43508 15.3772C6.80199 14.1212 8.58617 13.4167 10.4425 13.4C11.8976 13.327 13.2642 12.6796 14.2425 11.6L15.3425 10.6L20.6425 15.9L19.9425 16.7C19.3765 17.2228 18.9246 17.8568 18.6149 18.5623C18.3051 19.2677 18.1443 20.0295 18.1425 20.8Z",
    fill: "url(#paint0_linear_20_328)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_328",
    x1: 22.5145,
    y1: 29.1868,
    x2: 2.63352,
    y2: 11.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C6060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B5139"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeat);
export default __webpack_public_path__ + "static/media/meat.95fe25818eb672eca2396cc84dbf442f.svg";
export { ForwardRef as ReactComponent };